export const environment = {
  production: false,
  preproduction: false,
  api: {
    BASE_URL: 'https://dev-api.collary.fr/api/api',
    BASE_URL_NOTIF: 'https://dev-api.collary.fr/api',
    AUTH_URL: 'https://dev-api.collary.fr/api/auth',

    // BASE_URL: 'http://localhost:8080/api/api',
    // BASE_URL_NOTIF: 'http://localhost:8080/api',
    // AUTH_URL: 'http://localhost:8080/api/auth',

    OPEN_STREET_URL: 'https://nominatim.openstreetmap.org/search?format=json',
    COMMUNES_URL: 'https://geo.api.gouv.fr/communes',
    REGIONS_URL: 'https://geo.api.gouv.fr/regions',
    DEPARTMENTS_URL: 'https://geo.api.gouv.fr/departements',
    URL: 'https://dev-team.collary.fr',
  },
  BASE_64: 'data:image/jpeg;base64,',
  AUTHORIZATION: 'Bearer eyJhY2Nlc3MtdG9rZW4iOiJVZVdkdm81ZEdDSXdCdjVLWDUweVdBIiwidG9rZW4tdHlwZSI6IkJlYXJlciIsImNsaWVudCI6ImRraHZiZUNyS1ZnOHNpS2pFRVF3blEiLCJleHBpcnkiOiIxNzIyNTYxMzQzIiwidWlkIjoiYWxhYUBnbWFpbC5jb20ifQ==',
  appName: 'Collary Team - DEV',
  version: '1.0.0-dev'
};
